module.exports = __webpack_public_path__ + "acv_slide_mobile.webp";